/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListUserAccountEntity } from '../models/api-response-list-user-account-entity';
import { ApiResponseString } from '../models/api-response-string';
import { ApiResponseUserAccountEntity } from '../models/api-response-user-account-entity';
import { getUser } from '../fn/user-api/get-user';
import { GetUser$Params } from '../fn/user-api/get-user';
import { getUserByCompanyId } from '../fn/user-api/get-user-by-company-id';
import { GetUserByCompanyId$Params } from '../fn/user-api/get-user-by-company-id';
import { getUserByUsername } from '../fn/user-api/get-user-by-username';
import { GetUserByUsername$Params } from '../fn/user-api/get-user-by-username';
import { getUserForTicket } from '../fn/user-api/get-user-for-ticket';
import { GetUserForTicket$Params } from '../fn/user-api/get-user-for-ticket';
import { updateLastLogin } from '../fn/user-api/update-last-login';
import { UpdateLastLogin$Params } from '../fn/user-api/update-last-login';
import { updateUser } from '../fn/user-api/update-user';
import { UpdateUser$Params } from '../fn/user-api/update-user';
import { UserAccountEntity } from '../models/user-account-entity';

@Injectable({ providedIn: 'root' })
export class UserApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/v1/api/user-api/update/{componentName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAccountEntity>> {
    return updateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<UserAccountEntity> {
    return this.updateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAccountEntity>): UserAccountEntity => r.body)
    );
  }

  /** Path part for operation `updateLastLogin()` */
  static readonly UpdateLastLoginPath = '/v1/api/user-api/update/last-login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLastLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLastLogin$Response(params: UpdateLastLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseUserAccountEntity>> {
    return updateLastLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLastLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLastLogin(params: UpdateLastLogin$Params, context?: HttpContext): Observable<ApiResponseUserAccountEntity> {
    return this.updateLastLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseUserAccountEntity>): ApiResponseUserAccountEntity => r.body)
    );
  }

  /** Path part for operation `getUser()` */
  static readonly GetUserPath = '/v1/api/user-api/get/{keycloakId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser$Response(params: GetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAccountEntity>> {
    return getUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: GetUser$Params, context?: HttpContext): Observable<UserAccountEntity> {
    return this.getUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAccountEntity>): UserAccountEntity => r.body)
    );
  }

  /** Path part for operation `getUserByUsername()` */
  static readonly GetUserByUsernamePath = '/v1/api/user-api/get/get-by-username/{companyId}/{username}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserByUsername()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserByUsername$Response(params: GetUserByUsername$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseUserAccountEntity>> {
    return getUserByUsername(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserByUsername$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserByUsername(params: GetUserByUsername$Params, context?: HttpContext): Observable<ApiResponseUserAccountEntity> {
    return this.getUserByUsername$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseUserAccountEntity>): ApiResponseUserAccountEntity => r.body)
    );
  }

  /** Path part for operation `getUserByCompanyId()` */
  static readonly GetUserByCompanyIdPath = '/v1/api/user-api/get/gat-by-company/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserByCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserByCompanyId$Response(params: GetUserByCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListUserAccountEntity>> {
    return getUserByCompanyId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserByCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserByCompanyId(params: GetUserByCompanyId$Params, context?: HttpContext): Observable<ApiResponseListUserAccountEntity> {
    return this.getUserByCompanyId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListUserAccountEntity>): ApiResponseListUserAccountEntity => r.body)
    );
  }

  /** Path part for operation `getUserForTicket()` */
  static readonly GetUserForTicketPath = '/v1/api/user-api/get-user-for-ticket/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserForTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserForTicket$Response(params: GetUserForTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return getUserForTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserForTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserForTicket(params: GetUserForTicket$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.getUserForTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

}
